// ═══════════════════════════════════════════════════════════
//  FEMCARE BOOKING — Dynamic JSON Config
//  Each appointment type drives all subsequent screens
// ═══════════════════════════════════════════════════════════

export const APPOINTMENT_TYPES = [
  {
    id: "doctor",
    icon: "👩‍⚕️",
    title: "Doctor Consultation",
    sub: "General health consultation",
  },
  {
    id: "pregnancy",
    icon: "🤰",
    title: "Pregnancy Check-up",
    sub: "ANC, pregnancy care",
  },
  {
    id: "scan",
    icon: "🔬",
    title: "Scan or Lab Review",
    sub: "Upload & review reports",
  },
  {
    id: "pcos",
    icon: "🩺",
    title: "PCOS / Period Problem",
    sub: "Irregular cycles, acne, etc.",
  },
];

export const CONSULTATION_MODES = [
  {
    id: "clinic",
    icon: "🏥",
    title: "In-clinic Visit",
    sub: "Visit the clinic in person",
  },
  {
    id: "video",
    icon: "🎥",
    title: "Video Consultation",
    sub: "Consult from home via video",
  },
  {
    id: "phone",
    icon: "📞",
    title: "Phone Consultation",
    sub: "Audio call with your doctor",
  },
];

export const PAYMENT_METHODS = [
  {
    id: "upi",
    icon: "📱",
    title: "UPI",
    sub: "Google Pay, PhonePe, Paytm, BHIM",
  },
  {
    id: "card",
    icon: "💳",
    title: "Debit / Credit Card",
    sub: "Visa, Mastercard, Rupay",
  },
  {
    id: "netbanking",
    icon: "🏦",
    title: "Net Banking",
    sub: "All major banks supported",
  },
  {
    id: "wallet",
    icon: "👛",
    title: "Wallets",
    sub: "Paytm, Mobikwik, Amazon Pay",
  },
];

// ─── Per-Type Config ─────────────────────────────────────

export const TYPE_CONFIGS = {
  doctor: {
    recommendation: {
      title: "General Consultation",
      subtitle: "Doctor consultation · General health",
      icon: "👩‍⚕️",
      badge: "⭐ Recommended",
      reasonSummary: "General health concern, wellness check-up",
      includes: [
        "Gynecologist consultation",
        "Health & wellness assessment",
        "Lifestyle & nutrition guidance",
        "Personalized care plan",
      ],
      context: {
        "Life Stage": "Reproductive Age",
        "Main Concern": "General wellness",
        "Visit Type": "First consultation",
      },
    },
    doctors: [
      {
        id: "doc-1",
        name: "Dr. Shruti Nikam",
        title: "Senior Consultant – Gynecology",
        emoji: "👩‍⚕️",
        rating: 5,
        reviews: 142,
        exp: "8+ yrs exp",
        tags: ["General Health", "Women's Wellness", "Preventive Care"],
        avail: "Today, 5:30 PM",
        recommended: true,
      },
     
    ],
    fee: 700,
    location: "161/13, Siyona Heights, Opp. Brick Castle, Near Kalyan Bhel, Pune, 411028, MAHARASTRA, India",
  },

  pregnancy: {
    recommendation: {
      title: "Pregnancy Care Package",
      subtitle: "Antenatal care · Pregnancy monitoring",
      icon: "🤰",
      badge: "⭐ Recommended",
      reasonSummary: "Pregnancy monitoring, antenatal checkup",
      includes: [
        "OB-GYN consultation",
        "Fetal growth assessment",
        "Nutritional guidance",
        "Antenatal care plan",
      ],
      context: {
        "Life Stage": "Pregnancy",
        "Main Concern": "Antenatal care",
        "Trimester": "To be confirmed",
      },
    },
    doctors: [
      {
        id: "priya",
        name: "Dr.Sruthi Nikam",
        title: "Senior OB-GYN Specialist",
        emoji: "👩‍⚕️",
        rating: 4.9,
        reviews: 210,
        exp: "8+ yrs exp",
        tags: ["Obstetrics", "High-Risk Pregnancy", "ANC"],
        avail: "Today, 4:00 PM",
        recommended: true,
      },
      {
        id: "sunita",
        name: "Dr. Sunita Reddy",
        title: "Consultant – Obstetrics & Gynecology",
        emoji: "👩‍⚕️",
        rating: 4.8,
        reviews: 167,
        exp: "11+ yrs exp",
        tags: ["Pregnancy Care", "Prenatal", "Postnatal"],
        avail: "Tomorrow, 10:00 AM",
        recommended: false,
      },
    ],
    fee: 1200,
    location: "161/13, Siyona Heights, Opp. Brick Castle, Near Kalyan Bhel, Pune, 411028, MAHARASTRA, India",
  },

  scan: {
    recommendation: {
      title: "Scan & Lab Report Review",
      subtitle: "Diagnostic review · Scan analysis",
      icon: "🔬",
      badge: "⭐ Recommended",
      reasonSummary: "Lab or scan report analysis and interpretation",
      includes: [
        "Report interpretation by specialist",
        "Ultrasound / MRI review",
        "Blood test analysis",
        "Follow-up recommendation",
      ],
      context: {
        "Life Stage": "Reproductive Age",
        "Main Concern": "Report review",
        "Report Type": "To be uploaded",
      },
    },
    doctors: [
      {
        id: "kavitha",
        name: "Dr. Kavitha Menon",
        title: "Consultant – Radiology & Diagnostics",
        emoji: "👩‍⚕️",
        rating: 4.8,
        reviews: 88,
        exp: "12+ yrs exp",
        tags: ["Radiology", "Ultrasound", "Lab Review"],
        avail: "Today, 3:30 PM",
        recommended: true,
      },
      {
        id: "ritu",
        name: "Dr. Ritu Joshi",
        title: "Gynecologist & Diagnostics Specialist",
        emoji: "👩‍⚕️",
        rating: 4.6,
        reviews: 61,
        exp: "8+ yrs exp",
        tags: ["Scan Review", "Women's Diagnostics"],
        avail: "Tomorrow, 11:00 AM",
        recommended: false,
      },
    ],
    fee: 500,
    location: "161/13, Siyona Heights, Opp. Brick Castle, Near Kalyan Bhel, Pune, 411028, MAHARASTRA, India",
  },

  pcos: {
    recommendation: {
      title: "PCOS / Menstrual Health Consultation",
      subtitle: "Hormonal health · Cycle management",
      icon: "🩺",
      badge: "⭐ Recommended",
      reasonSummary: "Irregular periods, acne, weight gain",
      includes: [
        "Gynecologist consultation",
        "PCOS risk assessment",
        "Lab / scan review",
        "Personalized care plan",
      ],
      context: {
        "Life Stage": "Reproductive Age",
        "Main Concern": "PCOS concern",
        "Cycle Pattern": "Irregular",
      },
    },
    doctors: [
      {
        id: "ananya",
        name: "Dr. Ananya Sharma",
        title: "Senior Consultant – Gynecology",
        emoji: "👩‍⚕️",
        rating: 4.8,
        reviews: 142,
        exp: "9+ yrs exp",
        tags: ["PCOS", "Women's Health", "Reproductive Health"],
        avail: "Today, 5:30 PM",
        recommended: true,
      },
      {
        id: "meera",
        name: "Dr. Meera Pathak",
        title: "Consultant – Gynecology",
        emoji: "👩‍⚕️",
        rating: 4.7,
        reviews: 98,
        exp: "10+ yrs exp",
        tags: ["PCOS", "Fertility", "Endocrine"],
        avail: "Tomorrow, 6:00 PM",
        recommended: false,
      },
    ],
    fee: 800,
    location: "161/13, Siyona Heights, Opp. Brick Castle, Near Kalyan Bhel, Pune, 411028, MAHARASTRA, India",
  },
};

// ─── Slots ───────────────────────────────────────────────

export const ALL_SLOTS = [
  "9:00 AM", "9:30 AM", "10:00 AM", "10:30 AM",
  "11:00 AM", "11:30 AM", "12:00 PM", "12:30 PM",
  "2:30 PM",  "3:00 PM",  "3:30 PM",  "4:00 PM",
  "5:00 PM",  "5:30 PM",  "6:00 PM",  "6:30 PM",
  "7:00 PM",  "7:30 PM",
];

export const MANUALLY_DISABLED_SLOTS = ["2:30 PM", "7:30 PM"];